import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import { Draggable } from '@client/components/DnD'
import {
  BlockModel,
  NULL as BlockModelNULL,
} from '@client/components/Block/model'
import { createBlockModel } from '@client/components/Block'
import { CLASS_NAMES } from '@client/components/constants'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import { SECTION_TYPES_VALUES } from '@client/components/Section/constants'
import {
  FIELD_TYPES_VALUES,
  BLOCK_TYPES,
} from '@client/components/Block/constants'

@inject('app', 'editor')
@observer
class DraggableWrapper extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(BlockModel),
    move: PropTypes.bool,
    app: PropTypes.instanceOf(AppModel),
    editor: PropTypes.instanceOf(EditorModel),
    children: PropTypes.element.isRequired,
    isDraggable: PropTypes.bool,
  }

  static defaultProps = {
    data: BlockModelNULL,
    move: false,
    app: AppModelNULL,
    editor: EditorModelNULL,
    isDraggable: true,
  }

  constructor(props) {
    super(props)

    props.data.move = props.move
  }

  onDragStart = (event, el) => {
    let model = this.props.data

    if (!this.props.isDraggable) {
      return
    }

    if (this.props.move) {
      el.classList.add(CLASS_NAMES.BLOCK_IS_MOVING)
    } else {
      const isSection = SECTION_TYPES_VALUES.indexOf(model.type) > 0
      const isField = FIELD_TYPES_VALUES.indexOf(model.type) > 0
      let type = model.type
      let sectionType = model.sectionType
      let fieldType = model.fieldType
      if (isSection) {
        type = BLOCK_TYPES.SECTION
        sectionType = model.type
      }
      if (isField) {
        type = BLOCK_TYPES.FIELD
        fieldType = model.type
      }
      const options = {
        type: type,
        sectionType: sectionType,
        fieldType: fieldType,
        blockId: model.blockId,
      }
      model = createBlockModel(options, this.props.editor)
    }

    this.props.app.setDraggedComponent(model)
  }

  onDragEnd = (event, el) => {
    this.props.app.setDraggedComponent(BlockModelNULL)
    if (this.props.move && el && el.classList) {
      el.classList.remove(CLASS_NAMES.BLOCK_IS_MOVING)
    }
  }

  render() {
    if (!this.props.isDraggable) {
      return this.props.children
    }
    return (
      <Draggable onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
        {this.props.children}
      </Draggable>
    )
  }
}

export default DraggableWrapper
